import { render, staticRenderFns } from "./RdmReadMore.vue?vue&type=template&id=616e55ea&scoped=true"
import script from "./RdmReadMore.vue?vue&type=script&lang=ts"
export * from "./RdmReadMore.vue?vue&type=script&lang=ts"
import style0 from "./RdmReadMore.vue?vue&type=style&index=0&id=616e55ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616e55ea",
  null
  
)

export default component.exports